/* 🤖 this file was generated by svg-to-ts */
export const matIconSettingsOverscan: {
  name: 'settings-overscan';
  data: string;
} = {
  name: 'settings-overscan',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.01 5.5 10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"/></svg>`
};
